import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useGetAccessSession } from '@client-app-sdk';

import AppModal from '@common/components/AppModal';
import AccessSessionHeader from '@MyAccess/components/AccessSessionHeader';
import AccessSessionHeaderSkeleton from '@MyAccess/components/AccessSessionHeaderSkeleton';
import { SESSION_ID_REQUEST_PARAM } from '@MyAccess/utils/consts';
import AccessRequestFormFilledSession from '@NewRequest/organisms/AccessRequestFormFilledSession';

export default function AccessSessionRequestModal() {
  const [queryParams, setQueryParams] = useSearchParams();
  const sessionId = queryParams.get(SESSION_ID_REQUEST_PARAM);

  const handleClose = () => {
    queryParams.delete(SESSION_ID_REQUEST_PARAM);
    setQueryParams(queryParams);
  };

  const modalTitle = useMemo(() => {
    if (!sessionId) return null;
    return <AccessSessionRequestTitle sessionId={sessionId} />;
  }, [sessionId]);

  return (
    <AppModal title={modalTitle} open={!!sessionId} onClose={handleClose}>
      {sessionId && <AccessRequestFormFilledSession sessionId={sessionId} />}
    </AppModal>
  );
}

function AccessSessionRequestTitle({ sessionId }: { sessionId: string }) {
  const { data: session, isFetched, isError } = useGetAccessSession({ id: sessionId });

  if (!isFetched) {
    return <AccessSessionHeaderSkeleton withArrow={false} />;
  }

  if (isError || !session) {
    return null;
  }

  return (
    <AccessSessionHeader
      icon={session.type.icons.svg}
      name={session.name}
      typeName={session.type.name}
      withArrow={false}
    />
  );
}
